import {useContext, useMemo} from 'react';
import {useStyle} from '../../base/hooks';
import {LayoutDebugVisualizerContext} from './types';

export const useDebugBorders = (): string => {
  const debugBordersVisualizerContext = useContext(
    LayoutDebugVisualizerContext,
  );
  const debugBorderColor = useMemo(() => getRandomColor(), []);
  return useStyle(
    () => ({
      ...(debugBordersVisualizerContext?.showDebugBorders === 'show'
        ? {
            borderColor: debugBorderColor.foreground,
            borderWidth: 1,
            borderStyle: 'solid',
          }
        : {}),
    }),
    [debugBordersVisualizerContext],
  );
};

function getRandomColor(): {foreground: string; background: string} {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return {foreground: color, background: color + '05'};
}
